import SpeechArea from './SpeechArea';

export default SpeechArea;
